<div class="tsn-panel tsn-assign">
  <div class="tsn-assign-head">
    <h6 class="m-0">Zugewiesene Stationen</h6>
    <button *canAccess="[1]" class="btn btn-sm btn-danger rounded-0" type="button" (click)="openAssignDialog()">Zuweisen</button>
  </div>
  <div class="tsn-assign-list" *ngIf="assignedStations.length > 0; else noAssigned">
    <ng-container *ngFor="let grp of assignedGroups">
      <div class="tsn-assign-group">{{ grp.name }}</div>
      <div class="tsn-assign-item" *ngFor="let station of grp.stations">
        <span class="tsn-assign-main">
          <avs-station-meta-info [metaInformation]="metaForStation(station)" [x]="station.x" [y]="station.y" layout="inline"></avs-station-meta-info>
          <span class="tsn-assign-name">{{ station.name }}</span>
        </span>
        <span class="tsn-assign-types">
          <span class="tsn-type-block" *ngFor="let t of assignedTypeBlocks(station)"
            [style.background]="t.color" [style.color]="t.text" [title]="t.label">{{ t.label }}</span>
        </span>
        <button *canAccess="[1]" class="tsn-icon-btn danger" type="button" (click)="removeAssignment(station)" title="Zuweisung entfernen">🗑</button>
      </div>
    </ng-container>
  </div>
  <ng-template #noAssigned>
    <p class="text-secondary small m-0">Dieser Zeitschaltuhr sind noch keine Stationen zugewiesen.</p>
  </ng-template>
</div>
